const WORKSPACE_BUILDER = 'workspace-builder-view';
const WORKSPACE_BROWSER = 'workspace-browser-view';
const MODAL = 'modal';

const validViews = [
  WORKSPACE_BUILDER,
  WORKSPACE_BROWSER,
  MODAL
];

module.exports = {
  WORKSPACE_BUILDER,
  WORKSPACE_BROWSER,
  MODAL,
  validViews
};
